<template>
	<section class="promotions main-content align-left">
		<div v-for="(row, rowIndex) in rows" :key="rowIndex" class="row promotions-row flex-row slide-row">
			<client-only>
				<BlockOverviewCard
					v-for="item in row"
					:key="item.ID"
					:item="item"
					:rooms="rooms"
					:locale-path="localePath"
				/>
			</client-only>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

const props = defineProps({
	packages: { type: Array, default: () => [] },
	amount: { type: Number, default: 99 },
	rooms: { type: Boolean, default: false },
});

const rows = computed(() => {
	const size = 4;
	const limitedPackages = props.amount ? props.packages.slice(0, props.amount) : props.packages;
	const out = [];
	for (let i = 0; i < limitedPackages.length; i += size) {
		out.push(limitedPackages.slice(i, i + size));
	}

	return out;
});
</script>

<style lang="scss" scoped>
.row-header {
	max-width: 1680px;
	padding: 0 16px;
}

.columns {
	padding: 0;
	display: flex;
	justify-content: space-between;
}

.button {
	align-self: center;
	margin: 0;
}
</style>
